import React from 'react';
import { cloneDeep, isEmpty } from 'lodash';
import { useSelector } from 'react-redux';
import { useComponent } from '../../UserSetting/UsersLibrary/UserRights';
import CommonMultiSelect from '../../../Components/Utility/FilterAction/CommonMultiSelect';
import CustomTooltip from '../../../Components/Tooltip/CustomTooltip';
import '../SystemMasters.css';
// eslint-disable-next-line import/order
import { useTranslation } from 'react-i18next';

export default function DropdownCard({
  item,
  index,
  handleChanged,
  addValueForLabel,
  activeInactiveClicked,
  handleDelete,
  handleValueChanged,
  openList,
  setOpenList,
  handleCheckboxCA,
  masterAddEditAccess,
  masterDeleteAccess,
  onDropSelectionChange,
  onDropBrandChange,
  isUniqueId,
}) {
  const { t } = useTranslation('common');
  const { CheckActionPermission } = useComponent();
  const reducer = useSelector((estate) => estate);
  const {
    Users: { logInRights },
    SystemMastersDetails: { pcTypeList, brandList },
  } = reducer;
  const MasterAddEditAccess = CheckActionPermission(logInRights, 'masters', 'customAttribute', 'addEdit');
  const handleOpenLabelOption = (optionIndex) => {
    let data = cloneDeep(openList);

    if (data.includes(optionIndex)) {
      const indexOf = data.indexOf(optionIndex);
      if (indexOf > -1) {
        // only splice array when item is found
        data.splice(indexOf, 1); // 2nd parameter means remove one item only
      }
    } else {
      data = [index, ...data];
    }
    setOpenList(data);
  };

  return (
    <div className="d-flex align-items-center justify-content-center">
      {item?._id !== '' && (
        <div className="common-checkbox ml-2">
          <input type="checkbox" name={`checkbox_DD${index}`} id={`customAttribute_DD_${item?._id}`} onChange={handleCheckboxCA} checked={item?.isChecked} />
          <label htmlFor={`customAttribute_DD_${item?._id}`} className="chklabel">
            <span />
          </label>
        </div>
      )}
      <div className="card listing-card mx-12 p-2 mb-2 flex-fill" key={index}>
        <div className="dropdown-container">
          <div className="input-container">
            <div className="input-group form-floating-label fixed-label">
              <input
                key={index}
                name="freeLabel"
                autoFocus={!item?._id}
                value={item?.keyName ? item?.keyName : ''}
                placeholder={t('DROP_DOWN_CARD.ENTER_LABEL')}
                type="text"
                onChange={(e) => handleChanged(e, index)}
                className="form-control"
                disabled={!MasterAddEditAccess}
              />
              <label htmlFor="text" className="text-bold f-16 asterisk-req">
                {t('DROP_DOWN_CARD.LABEL')}
                <span>*</span>
              </label>
            </div>
            {item?.isEmpty && (item?.keyName === null || item?.keyName === '') && (
              <label className="text-danger m-0 p-1">{t('DROP_DOWN_CARD.LABEL_REQUIRED')}</label>
            )}
          </div>
          <div className="input-action d-flex">
            {item?._id !== '' && masterAddEditAccess && (
              <>
                <CustomTooltip tooltipText={item?.isActive ? 'Active' : 'Inactive'}>
                  <button
                    type="button"
                    className=" mr-0"
                    onClick={() => activeInactiveClicked(item?._id)}
                    id={item?._id}
                    aria-label={item?.isActive ? 'Active' : 'Inactive'}
                  >
                    <span className={item?.isActive ? 'icon-active f-24' : 'icon-inactive f-24'} />
                  </button>
                </CustomTooltip>

                <CustomTooltip tooltipText="Add">
                  <button type="button" className=" mr-0" onClick={() => addValueForLabel(item?._id, index)} id={item?._id} aria-label="Add">
                    <span className="icon-Add f-24" />
                  </button>
                </CustomTooltip>
              </>
            )}

            <CustomTooltip tooltipText={t('CUSTOM_ATTRIBUTES.ADD_OPTION')}>
              <button
                type="button"
                className="position-relative mr-0"
                onClick={() => {
                  handleOpenLabelOption(index);
                }}
              >
                {openList.includes(index) ? (
                  <span className="icon-new-down-arrow-icon f-24 icon-dropdown icon-inverse" />
                ) : (
                  <span className="icon-new-down-arrow-icon f-24 icon-dropdown" />
                )}
              </button>
            </CustomTooltip>
            {masterDeleteAccess && (
              <CustomTooltip tooltipText={t('CUSTOM_ATTRIBUTES.DELETE')}>
                <button
                  type="button"
                  className=" mr-0"
                  onClick={() => {
                    handleDelete(item?._id ? item?._id : index);
                  }}
                  aria-label="delete"
                >
                  <span className="icon-Delete f-24" />
                </button>
              </CustomTooltip>
            )}
          </div>
        </div>
        {!isEmpty(isUniqueId) && isUniqueId?.includes(index) && <label className="text-danger m-0 p-1">{t('DROP_DOWN_CARD.ENTRY_EXIST')}</label>}
        <div className="common-react-select mb-1">
          <CommonMultiSelect
            label={t('DROP_DOWN_CARD.PRODUCT_TYPE')}
            required
            onChange={(e) => onDropSelectionChange(e, index)}
            selectedValue={item?.productType}
            optionList={pcTypeList?.map((e) => ({
              ...e,
              disabled: item?._id && item?.isUsedProductType?.includes(e._id?.toString()) && item?.productType?.includes(e._id?.toString()),
            }))}
            selectLabel="name"
            selectValue="_id"
            className="product-custom-multiselect common-new-multiselect w-100 text-bold mt-2"
            disable={!MasterAddEditAccess}
          />
          {item?.isEmpty && item?.productType?.length === 0 && <label className="text-danger m-0 p-1">{t('DROP_DOWN_CARD.PRODUCT_TYPE_REQUIRED')}</label>}
        </div>
        <div className="common-react-select mb-1">
          <CommonMultiSelect
            label="Brand"
            required
            onChange={(e) => onDropBrandChange(e, index)}
            selectedValue={item?.brand}
            optionList={brandList
              ?.filter((e) => e.isActive)
              .map((e) => ({
                ...e,
                disabled: item?._id && item?.isUsedBrand?.includes(e._id?.toString()),
              }))}
            selectLabel="name"
            selectValue="_id"
            className="product-custom-multiselect common-new-multiselect w-100 text-bold mt-2"
            disable={!MasterAddEditAccess}
          />
          {item?.isEmpty && (!item?.brand || item?.brand.length === 0) && <label className="text-danger m-0 p-1">{t('DROP_DOWN_CARD.BRAND_REQUIRED')}</label>}
        </div>
        {!isEmpty(item?.values || []) ? (
          item?.values?.map((eleValue, indexValue) => {
            return (
              <div key={eleValue?._id} className={openList.includes(index) ? 'dropdown-items show' : 'dropdown-items '}>
                <div className="freetext-container mt-2 mx-0">
                  <input
                    name="aliasName"
                    value={eleValue?.aliasName}
                    maxLength={5}
                    onChange={(e) => handleValueChanged(e, indexValue, index)}
                    className="w-50px mr-2"
                    disabled={!masterAddEditAccess}
                  />
                  <div className="input-container">
                    <div className="input-group form-floating-label fixed-label">
                      <input
                        key={eleValue?._id}
                        name="keyName"
                        autoFocus={!eleValue._id}
                        disabled={!masterAddEditAccess}
                        value={eleValue.keyName ? eleValue.keyName : ''}
                        placeholder={t('DROP_DOWN_CARD.ENTER_VALUE')}
                        type="text"
                        onChange={(e) => handleValueChanged(e, indexValue, index)}
                        className="form-control"
                      />
                      <label htmlFor="text" className="asterisk-req">
                        {t('DROP_DOWN_CARD.VALUE')} {indexValue + 1}
                        <span>*</span>
                      </label>
                      {item?.isEmpty && (item?.keyName === null || item?.keyName === '') && (
                        <label htmlFor="text" className="text-danger m-0 p-1">
                          {t('DROP_DOWN_CARD.VALUE_REQUIRED')}
                        </label>
                      )}
                    </div>
                  </div>
                  <div className="input-action d-flex">
                    {eleValue._id !== '' && masterAddEditAccess && (
                      <CustomTooltip tooltipText={t('CUSTOM_ATTRIBUTES.ACTIVE_INACTIVE')}>
                        <button
                          type="button"
                          aria-label="Active"
                          className="btn p-0 custom-action mr-0"
                          onClick={() => activeInactiveClicked(eleValue._id)}
                          id={eleValue._id}
                        >
                          <span className={eleValue.isActive ? 'icon-active f-24' : 'icon-inactive f-24'} />
                        </button>
                      </CustomTooltip>
                    )}
                    {masterDeleteAccess && (
                      <CustomTooltip tooltipText={t('CUSTOM_ATTRIBUTES.DELETE')}>
                        <button
                          className=" mr-0"
                          type="button"
                          aria-label="Delete"
                          onClick={() => {
                            handleDelete(eleValue._id ? eleValue._id : indexValue, index);
                          }}
                        >
                          <span className="icon-Delete f-24" />
                        </button>
                      </CustomTooltip>
                    )}
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <div className={openList?.includes(index) ? 'dropdown-items show' : 'dropdown-items '}>
            <p className="mt-3 mb-0 text-center">{t('DROP_DOWN_CARD.NO_OPTIONS_FOUND')}</p>
          </div>
        )}
      </div>
    </div>
  );
}
